/**
 * @constructor
 */
export default function HoverObject($object) {

    var $target = $($object.data('hover-target')),
        hoverClass = 'on-hover';

    $object.on('mouseover', function () {
        $target.addClass(hoverClass);
    });

    $object.on('mouseleave', function () {
        $target.removeClass(hoverClass);
    });
};
